import { utils } from 'pixi.js'
import { splice } from '../utils/fast'

const { uid } = utils

function entitify(o) {
  o.id = uid()
  o.systems = []
  o.systemsDirty = false
  o.components = {}
  o.ecs = null

  o.addToECS = function addToECS(ecs) {
    this.ecs = ecs
    this.setSystemsDirty()
  }

  o.setSystemsDirty = function setSystemsDirty() {
    if (!this.systemsDirty && this.ecs) {
      this.systemsDirty = true
      this.ecs.entitiesSystemsDirty.push(this)
    }
  }

  o.addSystem = function addSystem(system) {
    this.systems.push(system)
  }

  o.removeSystem = function removeSystem(system) {
    const index = this.systems.indexOf(system)

    if (index !== -1) {
      splice(this.systems, index, 1)
    }
  }

  o.addComponent = function addComponent(component) {
    this.components[component.name] = component
    this.setSystemsDirty()
  }

  o.removeComponent = function removeComponent(name) {
    if (!this.components[name]) {
      return
    }

    this.components[name] = undefined
    this.setSystemsDirty()
  }

  o.updateComponent = function updateComponent(name, data) {
    const component = this.components[name]

    if (component) {
      const keys = Object.keys(data)

      for (const key of keys) {
        component[key] = data[key]
      }
    }
  }

  o.updateComponents = function updateComponents(componentsData) {
    const components = Object.keys(componentsData)

    for (const component of components) {
      this.updateComponent(component, componentsData[component])
    }
  }

  o.dispose = function dispose() {
    for (const system of this.systems) {
      system.removeEntity(this)
    }
  }

  return o
}

export default entitify
